/**
 * Shared constants for the poll trigger dialog.
 *
 * Keeping the interval bounds in one place ensures the dialog's validation
 * (isStep1Valid) and the interval input's own validation (intervalError) can't
 * silently diverge.
 */

/** Minimum allowed poll interval, in minutes. */
export const POLL_INTERVAL_MIN = 5;

/** Maximum allowed poll interval, in minutes. */
export const POLL_INTERVAL_MAX = 30;
